import React from 'react';
import { ReactComponent as SvgIconClose } from '../../icons/SVG/ICON_CLOSE.svg';
import SvgIcon from './SvgIcon';

export const IconClose = ({ className }: { className?: string }): JSX.Element => (
  <SvgIcon className={className}>
    <SvgIconClose />
  </SvgIcon>
);

export default IconClose;
